import { render, staticRenderFns } from "./CustomerDataStep.vue?vue&type=template&id=3d3fef22"
import script from "./CustomerDataStep.vue?vue&type=script&lang=js"
export * from "./CustomerDataStep.vue?vue&type=script&lang=js"
import style0 from "./CustomerDataStep.vue?vue&type=style&index=0&id=3d3fef22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports